export default "__VITE_ASSET__bI$Baec8__"